import { createGeneralSelectors } from '../_common/selectors';

const getShadeInciListStateSlice = state => state.shadeInciList;
export const { getById } = createGeneralSelectors(getShadeInciListStateSlice);
